<template>
  <!------ kremlin location start ------->
  <div class="kremlinlocation-area" :data-stage="stage">
      <ul class="d-flex justify-content-between">
          <li :class="stepClass(1)">
              <div :class="['number', stage == 1 ? 'active' : 'kremlinlocation-box']">
                  <div class="number">
                      <div class="text"><i v-if="stage > 1" class="fas fa-check"></i><span v-else>1</span></div>
                  </div>
                  <p>{{ $t("booking.details") }}</p>
              </div>
          </li>
          <li :class="['number', stage == 2 ? 'active' : 'kremlinlocation-box', stepClass(2)]">
              <div class="kremlinlocation-box">
                  <div class="number">
                      <div class="text"><i v-if="stage > 2" class="fas fa-check"></i><span v-else>2</span></div>
                  </div>
                  <p>{{ $t("booking.invitation") }}</p>
              </div>
          </li>
          <li :class="stepClass(3)">
              <div :class="['number', stage == 3 ? 'active' : 'kremlinlocation-box']">
                  <div class="number">
                      <div class="text"><span>3</span></div>
                  </div>
                  <p>{{ $t("booking.approval") }}</p>
              </div>
          </li>
      </ul>
  </div>
  <!------ kremlin location stop ------->
</template>

<script>
import imageUrlMixin from '@/utils/imageUrlMixin';

export default {
  mixins: [imageUrlMixin],
  props: {
    stage: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    stepClass(stepNumber) {
      if (this.stage > stepNumber) return 'completed';
      if (this.stage === stepNumber) return 'current';
      return 'upcoming';
    },
  },
};
</script>

<style scoped>
.banner_area {
  width: 100%;
  height: 120px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding: 34px 0;
}
.banner_area .banner_body {
  position: relative;
}
.banner_area .banner_body::before {
  content: "";
  position: absolute;
  top: 14px;
  left: 0;
  width: 85%;
  height: 3px;
  background: #fff;
  right: 0;
  margin: 0 auto;
}
.banner_area .banner_body .banner_box {
  text-align: center;
  position: relative;
  z-index: 9;
}
.banner_area .banner_body .banner_box .number {
  width: 30px;
  height: 30px;
  border: 2px solid #fff;
  line-height: 28px;
  color: #000;
  background: #fff;
  box-sizing: border-box;
  border-radius: 50%;
  font-size: 15px;
  font-weight: 600;
  margin: 0 auto 6px;
}
.banner_area .banner_body .banner_box h3 {
  color: #fff;
  margin: 0 0 0;
  padding: 0 0 0;
  font-size: 15px;
  font-weight: 400;
}
.banner_area .banner_body .banner_box .number.active {
  background: #0061ab;
  color: #fff;
}

/* ====================================================================== */
/* R5 Batch 7: Premium progress steps (1-2-3 פרטים → הזמנה → אישור)        */
/* ====================================================================== */
.kremlinlocation-area {
  margin: 14px auto 8px;
  padding: 0 12px;
  max-width: 720px;
}
.kremlinlocation-area > ul {
  list-style: none;
  margin: 0;
  padding: 6px 24px 0;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  position: relative;
}
/* connector line behind the 3 dots — base (upcoming) */
.kremlinlocation-area > ul::before {
  content: '';
  position: absolute;
  top: 18px;
  left: 12%;
  right: 12%;
  height: 2px;
  background: rgba(255, 255, 255, 0.45);
  z-index: 0;
  border-radius: 2px;
}
/* connector line — completed portion (filled progressively) */
.kremlinlocation-area > ul::after {
  content: '';
  position: absolute;
  top: 18px;
  /* base origin pinned to RTL-start (right) */
  right: 12%;
  height: 2px;
  background: linear-gradient(90deg, #28a745 0%, #1c7ed6 100%);
  z-index: 0;
  border-radius: 2px;
  transition: width 0.3s ease;
  width: 0;
}
.kremlinlocation-area[data-stage="2"] > ul::after { width: 38%; }
.kremlinlocation-area[data-stage="3"] > ul::after { width: 76%; }
.kremlinlocation-area > ul > li {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  margin: 0 !important;
  padding: 0 !important;
}
.kremlinlocation-area > ul > li .number {
  width: 36px;
  height: 36px;
  line-height: 32px;
  border-radius: 50%;
  background: #ffffff;
  color: #94a3b8;
  border: 2px solid rgba(255, 255, 255, 0.7);
  font-size: 14px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
}
.kremlinlocation-area > ul > li .number .text {
  display: inline-block;
}
.kremlinlocation-area > ul > li.active .number,
.kremlinlocation-area > ul > li > div.active .number {
  background: linear-gradient(135deg, #ffa500 0%, #ff7e00 100%);
  color: #ffffff;
  border-color: #ffffff;
  box-shadow: 0 2px 8px rgba(255, 126, 0, 0.4);
  transform: scale(1.08);
}
.kremlinlocation-area > ul > li p,
.kremlinlocation-area > ul > li > div > p {
  margin: 0 !important;
  padding: 0 !important;
  font-size: 11px !important;
  font-weight: 600 !important;
  color: #ffffff !important;
  text-align: center;
  line-height: 1.2 !important;
  display: block !important;
  width: 100%;
  white-space: nowrap;
}
.kremlinlocation-area > ul > li.active p,
.kremlinlocation-area > ul > li > div.active p {
  color: #ffffff !important;
  font-weight: 700 !important;
}
/* Inner number wrapper sometimes nested twice (li > div > div.number > .text) */
.kremlinlocation-area > ul > li > div {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  width: 100%;
}
.kremlinlocation-area > ul > li > div > .number {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #ffffff;
  color: #94a3b8;
  border: 2px solid rgba(255, 255, 255, 0.7);
  font-size: 14px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
}
.kremlinlocation-area > ul > li.active > div > .number,
.kremlinlocation-area > ul > li > div.active > .number {
  background: linear-gradient(135deg, #ffa500 0%, #ff7e00 100%);
  color: #ffffff;
  border-color: #ffffff;
  box-shadow: 0 2px 8px rgba(255, 126, 0, 0.4);
  transform: scale(1.08);
}
.kremlinlocation-area > ul > li > div > .number > .text {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

/* COMPLETED step — green check circle, signals "you already finished this" */
.kremlinlocation-area > ul > li.completed .number,
.kremlinlocation-area > ul > li.completed > div > .number {
  background: linear-gradient(135deg, #28a745 0%, #1e7e34 100%);
  color: #ffffff;
  border-color: #ffffff;
  box-shadow: 0 2px 8px rgba(40, 167, 69, 0.45);
}
.kremlinlocation-area > ul > li.completed .number .text i,
.kremlinlocation-area > ul > li.completed > div > .number .text i {
  font-size: 14px;
  color: #ffffff;
}
.kremlinlocation-area > ul > li.completed p,
.kremlinlocation-area > ul > li.completed > div > p {
  color: rgba(255, 255, 255, 0.92) !important;
  font-weight: 600 !important;
}

/* UPCOMING step — slightly faded so it reads as "not yet" */
.kremlinlocation-area > ul > li.upcoming .number,
.kremlinlocation-area > ul > li.upcoming > div > .number {
  background: rgba(255, 255, 255, 0.92);
  color: #cbd5e1;
  border-color: rgba(255, 255, 255, 0.6);
  box-shadow: none;
}
.kremlinlocation-area > ul > li.upcoming p,
.kremlinlocation-area > ul > li.upcoming > div > p {
  color: rgba(255, 255, 255, 0.78) !important;
  font-weight: 500 !important;
}

/* CURRENT — keep the strong orange (already styled by .active) but add subtle pulse */
@keyframes bnf-step-pulse {
  0%, 100% { box-shadow: 0 2px 8px rgba(255, 126, 0, 0.4); }
  50%      { box-shadow: 0 2px 14px rgba(255, 126, 0, 0.65); }
}
.kremlinlocation-area > ul > li.current .number,
.kremlinlocation-area > ul > li.current > div > .number {
  animation: bnf-step-pulse 2.2s ease-in-out infinite;
}
</style>

<style lang="less" scoped>
  .bonauf-desktop {
    .kremlinlocation-area {
      padding: 20px 14%;
    }
    .kremlinlocation-box {
      .number {
        width: 64px;
        height: 64px;
      }
    }
  }
</style>
